import React from 'react';
/*
To import child routes, insert the following code:
import { <childComponent>Routes } from './components/<child-folder>';
*/

import { Route } from '@plasma/ui.application.router';

const CompanyHome = React.lazy(() => import('.'));

export const companyHomeRoutes = [
  new Route({
    path: 'company-home',
    element: CompanyHome,
    children: [],
  }),
];
